import { render, staticRenderFns } from "./cs.vue?vue&type=template&id=2257f94a&scoped=true&"
var script = {}
import style0 from "./cs.vue?vue&type=style&index=0&id=2257f94a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2257f94a",
  null
  
)

export default component.exports